import { connect } from 'react-redux'
import Tile from 'components/tiled-menu/Tile'

const mapStateToProps = state => ({
  enterIfEmpty: state.precedents.content.enterIfEmpty
})

export default connect(mapStateToProps, null)(Tile)
